/* tb-adventskalender-selbst: Ins Türchen legen (/cart/add.js) und Türchen-Zähler. */
(function () {
  var root = document.querySelector('[data-tbak]');
  if (!root) return;
  var vorschau = root.hasAttribute('data-vorschau');
  var handles = {};
  // Handles dieser Section und des Packtischs (tb-ak-packtisch schreibt ebenfalls data-tbak-handles)
  document.querySelectorAll('[data-tbak-handles]').forEach(function (el) {
    try { JSON.parse(el.textContent).forEach(function (h) { handles[h] = 1; }); } catch (e) {}
  });
  var zaehler = root.querySelector('[data-tbak-zaehler]');
  var zellen = zaehler ? zaehler.querySelectorAll('i') : [];
  var text = zaehler ? zaehler.querySelector('[data-tbak-zaehler-text]') : null;
  var haken = '<svg viewBox="0 0 20 20" aria-hidden="true"><path d="M4 10.5l4 4 8-9" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var anzahl = 0;
  // Mit Packtisch zeigt der Zähler den Kalender (Türchen und Summe), nicht den Warenkorb (Runde 3, 20.10.2026)
  var mitKalender = document.documentElement.classList.contains('akp-da');
  var summeText = '';

  function zeige() {
    if (!zaehler) return;
    for (var i = 0; i < zellen.length; i++) zellen[i].classList.toggle('is-voll', i < Math.min(anzahl, 24) / 2);
    if (text) {
      if (zaehler.dataset.ohneZiel) text.textContent = anzahl >= 24 ? (zaehler.dataset.voll || 'Alle 24 Türchen gefüllt') : anzahl + ' Türchen gefüllt';
      else text.textContent = anzahl >= 24 ? (zaehler.dataset.voll || 'Alle 24 Türchen gefüllt') : anzahl + ' ' + (zaehler.dataset.text || 'von 24 Türchen gefüllt');
      if (mitKalender && summeText) text.textContent += ' · ' + summeText;
    }
    zaehler.classList.toggle('is-sichtbar', anzahl > 0);
    root.classList.toggle('tbak--zaehler', anzahl > 0);
  }

  function lade() {
    if (vorschau || mitKalender) return;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        anzahl = c.items.reduce(function (s, i) { return s + (handles[i.handle] ? i.quantity : 0); }, 0);
        zeige();
      })
      .catch(function () {});
  }

  // Theme-Warenkorb still nachziehen (Zähler oben + Inhalt der Seitenleiste), ohne die Leiste aufzuklappen.
  // Gleiche Schritte wie window.refreshCart() im Theme (component-cart.js), nur ohne .show().
  function themeWarenkorb() {
    var form = document.getElementById('AjaxCartForm');
    if (!form) return;
    fetch('?section_id=helper-cart')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var neu = new DOMParser().parseFromString(html, 'text/html');
        var f = neu.getElementById('AjaxCartForm'), sub = neu.getElementById('AjaxCartSubtotal');
        if (!f) return;
        form.innerHTML = f.innerHTML;
        if (form.ajaxifyCartItems) form.ajaxifyCartItems();
        var n = form.querySelector('[data-cart-count]'), t = form.querySelector('[data-cart-total]');
        document.querySelectorAll('[data-header-cart-count]').forEach(function (e) { if (n) e.textContent = n.textContent; });
        document.querySelectorAll('[data-header-cart-total]').forEach(function (e) { if (t) e.textContent = t.textContent; });
        var altSub = document.getElementById('AjaxCartSubtotal');
        if (sub && altSub) altSub.innerHTML = sub.innerHTML;
      })
      .catch(function () {});
  }

  // Sortenwahl: Knopf und Preis folgen der gewählten Sorte
  root.addEventListener('change', function (e) {
    var sel = e.target.closest('[data-tbak-sorte]');
    if (!sel) return;
    var karte = sel.closest('.tbak__karte');
    var opt = sel.options[sel.selectedIndex];
    var knopf = karte.querySelector('[data-tbak-add]');
    var preis = karte.querySelector('[data-tbak-preis]');
    if (knopf) knopf.dataset.variante = sel.value;
    if (preis && opt && opt.dataset.preis) preis.innerHTML = opt.dataset.preis;
    // Zur gewählten Sorte das passende Bild zeigen (Lene 20.10.)
    var bild = karte.querySelector('.tbak__bild img');
    if (bild && opt && opt.dataset.bild) {
      bild.removeAttribute('srcset'); bild.removeAttribute('sizes');
      bild.src = opt.dataset.bild;
      if (opt.dataset.bildAlt) bild.alt = opt.dataset.bildAlt;
    }
  });

  // Packtisch im Bild: dessen Leiste zeigt den Stand, der Zähler hier weicht
  var packtisch = document.querySelector('[data-akp]');
  if (packtisch && zaehler && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (eintraege) {
      zaehler.classList.toggle('is-verdeckt', eintraege[0].isIntersecting);
    }).observe(packtisch);
  }
  // Der Packtisch meldet seinen Stand (Kalender) und wenn er etwas in den Warenkorb gelegt hat
  document.addEventListener('akp:aenderung', function (e) { anzahl = e.detail.n; summeText = e.detail.n ? e.detail.text : ''; zeige(); });
  document.addEventListener('akp:warenkorb', function () { lade(); themeWarenkorb(); });
  document.addEventListener('akp:kitkorb', themeWarenkorb);

  // Slider: Pfeile blättern um etwa drei Karten, nur sichtbar, wenn es etwas zu blättern gibt
  root.querySelectorAll('[data-tbak-slider]').forEach(function (wrap) {
    var liste = wrap.querySelector('.tbak__slider');
    var zurueck = wrap.querySelector('[data-tbak-pfeil="-1"]'), weiter = wrap.querySelector('[data-tbak-pfeil="1"]');
    function pfeile() {
      var max = liste.scrollWidth - liste.clientWidth - 2;
      if (zurueck) zurueck.hidden = liste.scrollLeft <= 2;
      if (weiter) weiter.hidden = liste.scrollLeft >= max;
    }
    wrap.addEventListener('click', function (e) {
      var p = e.target.closest('[data-tbak-pfeil]');
      if (!p) return;
      var karte = liste.querySelector('.tbak__karte'), schritt = karte ? (karte.offsetWidth + 20) * 3 : 600;
      var ruhig = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      liste.scrollBy({ left: schritt * Number(p.dataset.tbakPfeil), behavior: ruhig ? 'auto' : 'smooth' });
    });
    liste.addEventListener('scroll', pfeile, { passive: true });
    window.addEventListener('resize', pfeile);
    pfeile();
  });

  root.addEventListener('click', function (e) {
    var knopf = e.target.closest('[data-tbak-add]');
    if (!knopf) return;
    e.preventDefault();
    if (knopf.getAttribute('aria-busy') === 'true') return;
    var fehler = knopf.parentElement.querySelector('.tbak__fehler');
    var vorher = knopf.innerHTML;
    knopf.setAttribute('aria-busy', 'true');
    knopf.textContent = 'Einen Moment …';
    var anfrage = vorschau
      ? new Promise(function (ok) { setTimeout(ok, 450); })
      : fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(knopf.dataset.variante), quantity: 1 }] })
        }).then(function (r) {
          if (r.ok) return r.json();
          return r.json().catch(function () { return {}; }).then(function (j) { throw new Error(j.description || ''); });
        });
    anfrage.then(function () {
      anzahl += 1;
      zeige();
      if (fehler) fehler.textContent = '';
      knopf.classList.add('is-drin');
      knopf.innerHTML = haken + (root.dataset.drin || 'Liegt im Kalender');
      document.dispatchEvent(new CustomEvent('tbak:warenkorb', { detail: { variante: knopf.dataset.variante } }));
      if (!vorschau) themeWarenkorb();
      setTimeout(function () { knopf.classList.remove('is-drin'); knopf.innerHTML = vorher; }, 2400);
    }).catch(function (err) {
      knopf.innerHTML = vorher;
      if (fehler) fehler.textContent = err.message || 'Das hat nicht geklappt. Bitte versuch es noch einmal.';
    }).then(function () { knopf.removeAttribute('aria-busy'); });
  });

  lade();
})();
